<template>
    <div class="position-relative d-flex flex-column h-100">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-chevron-left donation-back-icon"
            viewBox="0 0 16 16"
            @click="backStep"
        >
            <path
                fill-rule="evenodd"
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
            />
        </svg>
        <div class="flex-grow-1">
            <h2 class="donation-title text-center mb-3">
                Additional Information
            </h2>
            <TextField
                v-for="(question, index) in questions"
                v-bind:key="index"
                v-model="questions[index].answer"
                :name="`question${question.question_id}`"
                input-type="2"
                classWrapper="mb-3"
                :placeholder="question.question_text"
            />
        </div>
        <button @click="submit"
                :disabled="!isValid"
                class="btn w-100 ok-btn mt-3">
            Donate {{ donateAmount }}
        </button>
    </div>
</template>

<script>
import TextField from '@/commons/FormElements/TextField.vue';
export default {
    name: 'AdditionalInformation',
    components: {
        TextField,
    },
    props: {
        donateAmount: String,
        donationData: {
            type: Object,
            default: () => ({}),
        },
        donationFormData: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        isValid() {
            return this.questions.every((item) => item.answer !== '');
        },
    },
    created() {
        if (this.donationFormData.questions.length > 0) {
            this.donationFormData.questions.forEach(item => {
                this.questions.push({
                    question_id: item.question_id,
                    question_text: item.question_text,
                    answer: item.answer
                });
            })
        } else {
            this.donationData.questions.forEach(item => {
                this.questions.push({
                    question_id: item.question_id,
                    question_text: item.question_text,
                    answer: ''
                });
            })
        }
    },
    data() {
        return {
            questions: []
        };
    },
    methods: {
        backStep() {
            this.$emit('changeStep', 4);
            this.$emit('updateData', {
                questions: this.questions
            });
        },
        submit() {
            this.$emit('updateData', {
                questions: this.questions
            });
            this.$emit('changeStep', 6);
        },
    },
};
</script>
